import config from '@/config'
import lang from '@/lang'
import { CLIENT_CONNECTION_STATUS, CLIENT_INVITATION_STATUS } from './_helpers/getStatusLabel'

const urls = {
  single: 'client',
  multiple: 'clients',
}

export default {
  resourceUrl: `${config.resourceHost}${urls.single}`,
  clientListSetting: `${config.resourceHost}setting/userlist/client`,

  clientUrl: urls,

  routes: {
    details: `${config.resourceHost}${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  clientDetail: {
    jumpMarkLinks: {
      overview: 'overview',
      todo: 'todo',
      eSigning: 'eSigning',
      taxForm: 'taxForm',
      taxAccountantExport: 'taxAccountantExport',
      documentExport: 'documentExport',
      createdExports: 'createdExports',
    },
  },

  options: {
    list: {
      name: urls.single,
      quickfilters: {
        models: [
          { name: 'all', title: lang.label.allCapital },
        ],
      },
      defaultSort: { property: 'name', desc: false },
    },
  },
  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: {
        kind: {
          type: 'set',
          values: [],
        },
      },
    },
    {
      name: 'invited',
      title: lang.clientList.invitationStatus.invited,
      quickFilter: {
        inviteeStatus: {
          type: 'set',
          values: [CLIENT_INVITATION_STATUS.REQUESTED],
        },
        inviterStatus: {
          type: 'set',
          values: [CLIENT_INVITATION_STATUS.REQUESTED],
        },
        operator: 'OR',
      },
    },
    {
      name: 'connected',
      title: lang.clientList.connectionStatus.connected,
      quickFilter: {
        connectionStatus: {
          type: 'set',
          values: [CLIENT_CONNECTION_STATUS.CONNECTED],
        },
      },
    },
    {
      name: 'offline',
      title: lang.clientList.invitationStatus.offline,
      quickFilter: {
        inviteeStatus: {
          type: 'set',
          values: [CLIENT_INVITATION_STATUS.OFFLINE],
        },
        inviterStatus: {
          type: 'set',
          values: [CLIENT_INVITATION_STATUS.OFFLINE],
        },
        operator: 'OR',
      },
    },
  ],
}
